import { styled } from '@mui/material';

export const StyledP = styled('p')(({ theme }) => ({
    ...theme.fonts.body_2,
    margin: '0',
    padding: '0',
    color: theme.colors.white,
}));
